import styled from 'styled-components';
import React from 'react';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import BusinessDisplayUnitItem from '../BusinessDisplayUnitItem/BusinessDisplayUnitItem';

interface ServiceDirectoryBusinessDisplayUnitListProps {
    businessDisplayUnitList: BusinessDisplayUnit[];
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const StyledServiceDirectoryBusinessDisplayUnitList = styled.div``;

const ServiceDirectoryBusinessDisplayUnitList = ({
    businessDisplayUnitList,
    onSelect,
}: ServiceDirectoryBusinessDisplayUnitListProps) => {
    return (
        <StyledServiceDirectoryBusinessDisplayUnitList>
            {businessDisplayUnitList.map((businessDisplayUnit) => {
                return (
                    // eslint-disable-next-line react/jsx-key
                    <div>
                        <BusinessDisplayUnitItem
                            businessDisplayUnit={businessDisplayUnit}
                            onSelect={onSelect}
                        />
                    </div>
                );
            })}
        </StyledServiceDirectoryBusinessDisplayUnitList>
    );
};
export default ServiceDirectoryBusinessDisplayUnitList;
